import { type IconType } from '@assembly-js/design-system';

import {
  ModuleManagementListKeys,
  ModuleType,
  VisibilityRule,
} from 'src/constants';

export type SetupModulePageQueryParams = {
  moduleId: string;
  moduleType: ModuleType;
  preset: string;
  appId: string;
};

export enum ModuleTypes {
  Core = 'module',
  Global = 'global',
  Local = 'local',
  Authenticated = 'authenticated', // extension module that is authenticated (is saved as global)
}

export interface ModuleFormValuesType {
  id: ModuleManagementListKeys | '';
  label: string;
  icon: IconType;
  type: ModuleTypes; // when setting up module the type can also be `authenticated`
  embedCode?: string;
  autoSizeEmbed?: boolean;
  embedlyData?: any;
  disabled?: boolean; // used for disabled modules
  embedLink?: string;
  content?: string;
  viewType?: string;
  visibilityConfig: VisibilityRule[];
  queryParams?: { key: string; value: string }[];
}
